import Question from "../../Classes/Question";
import { questionViewerSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    currentQuestion: new Question(),
    addModal: false,
    editModal: false
}

export default function questionViewerSlice(state = initialState, action) {
    switch (action.type) {
        case questionViewerSliceDispatch.setCurrentQuestion: {
            return {
                ...state,
                currentQuestion: action.payload
            }
        }
        case questionViewerSliceDispatch.setAddModal: {
            return {
                ...state,
                addModal: action.payload
            }
        }
        case questionViewerSliceDispatch.setEditModal: {
            return {
                ...state,
                editModal: action.payload
            }
        }
        case questionViewerSliceDispatch.setIndexOverride: {
            return {
                ...state,
                indexOverride: action.payload
            }
        }
        case questionViewerSliceDispatch.setQuestionSearchResults: {
            return {
                ...state,
                questionSearchResults: action.payload
            }
        }
        default:
            return state
    }
}
